import React, { useState, useRef, useEffect } from 'react'

import InputStandard from 'components/input/standard'
import { emailIsValid } from 'utils'
import copy from 'fast-copy'

import Icon from 'components/icon/icon'

export default ({
    onChange,
    value,
    refreshSlider,
    defaultItem,
    innerRef,
}) => {
    const addedEmails = value || []

    const [inputValue, setInputValue] = useState('')
    const addedEmailsRef = useRef(addedEmails)
    const addedEmailsLengthRef = useRef(0)

    addedEmailsRef.current = addedEmails

    const handleInputValueChange = e => {
        setInputValue(e.target.value)
    }

    const handleAdd = _ => {
        const _value = inputValue ? inputValue.trim() : null

        if(_value && emailIsValid(_value)){
            if(!addedEmailsRef.current.find(addedEmail => addedEmail === _value)){
                const _addedEmails = copy(addedEmailsRef.current)

                _addedEmails.push(_value)

                onChange(_addedEmails)
            }

            setInputValue('')
        }
    }

    const handleRemove = email => {
        let _addedEmails = addedEmailsRef.current || []

        const emailIndex = _addedEmails.findIndex(_email => _email === email)

        _addedEmails.splice(emailIndex, 1)

        onChange(_addedEmails)
    }

    useEffect(() => {
        const addedEmailsLength = addedEmails.length

        if(refreshSlider && addedEmailsLengthRef.current !== addedEmailsLength){
            refreshSlider()
        }
    }, [addedEmails])

    return (
        <div 
            className={'invite-list'}
            onKeyPress={e => {
                if(e.key === 'Enter'){
                    e.stopPropagation()
                    e.preventDefault()
                }
            }}
            onClick={e => {
                e.preventDefault()
            }}
            onSubmit={e => {
                e.stopPropagation()
                e.preventDefault()
            }}
        >
            <ul className={'invited-address-list'}>
                <li>
                    <span>
                        <Icon name={'fe-user'} />
                        { defaultItem ? defaultItem : '' }
                    </span>
                </li>
                { addedEmails.map(addedEmail => {
                    return (
                        <li key={addedEmail}>
                            <span>
                                { addedEmail }
                            </span>
                            <button onClick={_ => handleRemove(addedEmail)}>
                                <Icon name={'fe-trash-2'} />
                            </button>
                        </li>
                    )
                })}
            </ul>
            <InputStandard
                placeholder={addedEmails.length ? `Hell yeah! Anyone else?` : `Enter a team member's email`}
                outlineOnFocus
                onChange={handleInputValueChange}
                value={inputValue}
                showPlus
                validate={'email'}
                callback={handleAdd}
                innerRef={innerRef}
            />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/input/invite-list.jsx